<template lang="pug">
  yz-card.px-6.py-5(color="white")
    .yz-heading-8.mb-3 {{ $t('panel.remarks') }}

    .yz-regular-body-sm
      span(v-if="remarksText") {{ remarksText }}
      span.text-neutral-500(v-else) {{ $t('na') }}
</template>

<script>
export default {
  props: {
    parentClaim: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    remarksText() {
      return this.parentClaim?.remarks
    }
  }
}
</script>

<style scoped></style>
